<h1 mat-dialog-title>Excel data upload - Error details</h1>
<div mat-dialog-content>
  <div [ngClass]="'initialPosition'">
    <div *ngIf="noRecordsShow" class="records">{{noRecords}}</div>
    <div class="example-container mat-elevation-z8" [ngClass]="'newHeight'">
      <table mat-table [dataSource]="dataSource" *ngIf="!noRecordsShow">

        <!-- Row Number Column -->
        <ng-container matColumnDef="RowNo">
          <th class="leftHeaderCell" mat-header-cell *matHeaderCellDef> Row No. </th>
          <td class="leftDataCell" mat-cell *matCellDef="let element"> {{element.Row}} </td>
        </ng-container>

        <!-- Reason Column -->
        <ng-container matColumnDef="Reason">
          <th class="leftHeaderCell" mat-header-cell *matHeaderCellDef> Reason </th>
          <td class="leftDataCell" mat-cell *matCellDef="let element" >
              <span>{{element.Reason}}</span>
          </td>
        </ng-container>

        <!-- Status Column -->
        <ng-container matColumnDef="Status">
          <th class="rightHeaderCell" mat-header-cell *matHeaderCellDef> Status </th>
          <td class="rightDataCell" mat-cell *matCellDef="let element"> {{element.Status}} </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns;sticky: true"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
      </table>
    </div>
  </div>
</div>

<div mat-dialog-actions>
  <button mat-button mat-raised-button color="primary" style="background-color: #18468b;" [mat-dialog-close]="data.name" cdkFocusInitial>Ok</button>
</div>